import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

// Logo Asera dipakai untuk semua varian (terang/gelap, besar/kecil).
// Diambil dari aset lokal di public/ supaya tidak bergantung ke situs
// asera.co.id yang bisa saja berubah sewaktu-waktu.
const ASERA_LOGO = `${process.env.PUBLIC_URL}/aseralogo3.png`;

const Sidebar = props => {

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={ASERA_LOGO} alt="Asera" height="16" />
            </span>
            <span className="logo-lg">
              <img src={ASERA_LOGO} alt="Asera" height="35" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={ASERA_LOGO} alt="Asera" height="16" />
            </span>
            <span className="logo-lg">
              <img src={ASERA_LOGO} alt="Asera" height="35" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          <SidebarContent />
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));